import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonSquareRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 9c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1h1.069A7 7 0 0 1 18 25h4a7.005 7.005 0 0 1 6.931 6H30c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm4.125 22h11.75A4.004 4.004 0 0 0 22 28h-4a4.004 4.004 0 0 0-3.875 3M6 10c0-2.206 1.794-4 4-4h20c2.206 0 4 1.794 4 4v20c0 2.206-1.794 4-4 4H10c-2.206 0-4-1.794-4-4zm14 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5m5.5 2.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" })
});
export default SvgPersonSquareRegularIcon;
